// Random id for client-side bookkeeping (status messages, calendar updates); never sent to the API.
export const createId = (): string =>
    Array.from(crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, "0")).join("");
